// material-ui
import { Button, Grid, Link, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import AnimateButton from 'components/@extended/AnimateButton';

// project-imports
import MainCard from 'components/MainCard';
import useHabihubBrandColors from 'hooks/useHabihubBrandColors';

// third-party
import { FormattedMessage, useIntl } from 'react-intl';

// assets
import cardBack from 'assets/images/widget/img-dropbox-bg.svg';
import cardImg from 'assets/images/banner/banner-developments.png';

// ==============================|| BANNER CARD - AGENTS CAMPAIGN ||============================== //

const BannerCard = () => {
  const theme = useTheme();
  const brandColors = useHabihubBrandColors();
  const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));

  const intl = useIntl();

  return (
    <>
      {matchDownMd ? (
        <MainCard
          content={false}
          border={false}
          sx={{
            my: 3,
            mx: matchDownMd ? 0 : 3,
            color: theme.palette.common.white,
            // bgcolor: theme.palette.primary.main,
            bgcolor: brandColors.gradientStart,
            '&:after': {
              content: '""',
              backgroundImage: `url(${cardBack})`,
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: -60,
              zIndex: 1,
              opacity: 0.5,
              backgroundPosition: 'center',
              backgroundSize: '200%',
              backgroundRepeat: 'no-repeat'
            }
          }}
        >
          <Stack alignItems="center" spacing={2.5} sx={{ position: 'relative', zIndex: 2 }}>
            <img
              src={cardImg}
              alt="logo"
              width={320}
              height={160}
              style={{
                width: '100%',
                height: 'auto',
                WebkitMaskImage: 'linear-gradient(to bottom, black 10%,transparent 100%)',
                maskImage: 'linear-gradient(to bottom, black 10%, transparent 100%)',
                WebkitMaskRepeat: 'no-repeat',
                maskRepeat: 'no-repeat'
              }}
            />
            <Stack alignItems="center" spacing={2} p={2}>
              <Stack alignItems="center" spacing={2}>
                <Typography variant="h5" sx={{ textAlign: 'center' }}>
                  {intl.formatMessage({ id: 'account.subscription.banner.title' })}
                </Typography>
                <Typography variant="h6" sx={{ textWrap: 'wrap', textAlign: 'center' }}>
                  {intl.formatMessage({ id: 'account.subscription.banner.description' })}
                </Typography>
              </Stack>
              <AnimateButton>
                <Button variant="contained" size="small" sx={{ textWrap: 'nowrap' }} component={Link} href="/account/subscription">
                  <FormattedMessage id="account.subscription.updatePlan" />
                </Button>
              </AnimateButton>
            </Stack>
          </Stack>
        </MainCard>
      ) : (
        <MainCard
          content={false}
          border={false}
          sx={{
            mt: '24px',
            color: theme.palette.common.white,
            // bgcolor: theme.palette.primary.main,
            bgcolor: brandColors.gradientStart,
            '&:after': {
              content: '""',
              backgroundImage: `url(${cardBack})`,
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 1,
              opacity: 0.5,
              backgroundPosition: 'center',
              backgroundSize: '100%',
              backgroundRepeat: 'no-repeat'
            }
          }}
        >
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ position: 'relative', zIndex: 2 }}>
            <img
              src={cardImg}
              alt="logo"
              width={320}
              height={160}
              style={{
                WebkitMaskImage: 'linear-gradient(to right, black 50%,transparent 100%)',
                maskImage: 'linear-gradient(to right, black 50%, transparent 100%)',
                WebkitMaskRepeat: 'no-repeat',
                maskRepeat: 'no-repeat'
              }}
            />
            <Grid container sx={{ width: '100%', height: 160 }}>
              <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Stack alignItems="center" spacing={1}>
                  <Typography variant="h5">{intl.formatMessage({ id: 'account.subscription.banner.title' })}</Typography>
                  <Typography variant="h6" sx={{ textWrap: 'wrap', textAlign: 'center' }}>
                    {intl.formatMessage({ id: 'account.subscription.banner.description' })}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <AnimateButton>
                  <Button variant="contained" size="medium" sx={{ textWrap: 'nowrap' }} component={Link} href="/account/subscription">
                    <FormattedMessage id="account.subscription.updatePlan" />
                  </Button>
                </AnimateButton>
              </Grid>
            </Grid>
          </Stack>
        </MainCard>
      )}
    </>
  );
};

export default BannerCard;
